// extracted by mini-css-extract-plugin
module.exports = {"icons":"contractualAccountSelect_icons__2oN1E","textContent":"contractualAccountSelect_textContent__2mUy4"};